import { render, staticRenderFns } from "./poinvpaym.vue?vue&type=template&id=74dbff90&scoped=true"
import script from "./poinvpaym.vue?vue&type=script&lang=js"
export * from "./poinvpaym.vue?vue&type=script&lang=js"
import style0 from "./poinvpaym.vue?vue&type=style&index=0&id=74dbff90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dbff90",
  null
  
)

export default component.exports